import { mapState, mapGetters, mapActions } from 'vuex'

export const authGetters = {
  ...mapGetters('auth', ['loggedIn', 'getUser']),
}

export const authActions = mapActions('auth', ['updateProfileFieldAction', 'updateProfileAction', 'logIn', 'logOut', 'register', 'resetPassword'])

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    sidebarSize: (state) => state.sidebarSize,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    mode: (state) => state.mode,
    position: (state) => state.position,
    sidebarView: (state) => state.sidebarView,
    sidebarColor: (state) => state.sidebarColor
  })
}




export const layoutMethods = mapActions('layout',
['changeLayoutType', 'changeLayoutWidth', 'changeSidebarSize', 'changeTopbar', 'changeMode', 'changePosition', 'changeSidebarView',
 'changeSidebarColor'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])

// export const profileMethods = mapActions('profile', ['updateProfile'])
